import React, { useState, useEffect } from 'react';
import ApexCharts from 'react-apexcharts';
import { BaseURL, uniqueToken } from '../../api/DataApis';
import axios from 'axios';
import Select from "react-select";
import Loader from '../Settings/Loader';


const LineChartApex = () => {
  document.title = "Charts"
  
  const [GraphData, setGraphData] = useState([]);
  const [Loading, setLoading] = useState('');
  const [FiltereddData, setFilteredData] = useState('');
  const [originalData, setOriginalData] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [selectedDays, setselectedDays] = useState(2);
  const [ChargerData, setChargerData] = useState([]);
  const [filteredChargerData, setFilteredChargerData] = useState([]);
  const [selectedEmi, setSelectedEmi] = useState([]);
  const [chargers, setChargers] = useState([]);


  const fetchChargerrs = async () => {
    setLoading(true);

    // Set the base API endpoint
    let apiEndpoint = `${BaseURL}/chargers`;

 try {
        const response = await axios.get(apiEndpoint, {
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: `Bearer ${uniqueToken}`,
            },
        });

        setChargerData(response.data.data.data || []);
        setFilteredChargerData(response.data.data.data || []); 

        const formattedChargers = response.data.data.data.map(charger => ({
          value: charger._id,  // The unique identifier (IMEI)
          label: charger.imei_number,          // The label to display in the dropdown
        }));
        setChargers(formattedChargers);

       
    } catch (error) {
        console.error("Error fetching ChargerData:", error);
    } finally {
        setLoading(false);
    }
};
console.log("chargerDataaaa", ChargerData);
useEffect(() => {
  fetchChargerrs();  // Fetch chargers based on the current page and search term
}, []);

const handleChargersChange = (selectedOptions) => {
  // Store the selected IMEI numbers in state
  const selectedEmis = selectedOptions ? selectedOptions.label: [];
  setSelectedEmi(selectedEmis);
};

  const handleDays =  (days) => {
    setselectedDays(days);
  }
 

  
 
// const [filteredData, setFilteredData]tate(originalData);

 const fetchGraphData = async () => {
    setLoading(true);
    
    const apiEndpoint = `${BaseURL}/dashboard/graph/${selectedEmi}?days=${selectedDays}`;
  
    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      
      // setChargerData(response.data.data || 
      // setFilteredConnectorsData(response.data.data|| []); 
      setGraphData(response?.data?.data);
      
  
     
    } catch (error) {
      console.error("Error fetching ChargerData:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGraphData();  // Fetch all chargers for the current page
  }, [selectedDays, selectedEmi]);
  
  useEffect(() => {
    if (GraphData?.dates) {
    
      setFilteredCategories(GraphData.dates); // Assuming GraphData.dates[0] is an array of numbers
      // setOriginalData();
      // setFilteredData(GraphData?.amountArr);
     // Initialize filtered categories
    }

    if(GraphData?.amountArr) {
      setOriginalData(GraphData.amountArr);
      setFilteredData(GraphData.amountArr);
    }
  }, [GraphData]);;// Example data
console.log("amountarrrr", originalData);
  

  const data = {
    series: [
      {
        name: 'Amount',
        data: FiltereddData,
      },
    ],
    options: {
      chart: {
        type: 'line',
        height: 350,
        zoom: {
          enabled: false,
        },
      },
      title: {
        text: 'Sales Over Time',
        align: 'left',
      },
      stroke: {
        curve: 'smooth',
        width: 3,
        colors: ['#0000FF'], // Default line color (blue)
      },
      xaxis: {
        title: {
          text: 'Month Days',
        },
        categories: filteredCategories,
      },
      yaxis: {
        title: {
          text: 'Income Per Day(In INR)',
        },
      },
      tooltip: {
        enabled: true,
      },
      annotations: {
        yaxis: [],
        xaxis: [],
      },
    },
  };


console.log("GraphData", GraphData);
console.log("originalData", originalData);
  return (
    
    <div>
      <h1>Line Chart for Payment</h1>
      <div style={{ marginBottom: '20px' }}>

        
      <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="chargers"
                              className="col-sm-2 control-label"
                            >
                              Select Charger
                            </label>
                            <div className="col-sm-6">
                              <Select
                                
                                options={chargers}
                                onChange={handleChargersChange}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="Please Select Charger to View Graph"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
      <button onClick={() => handleDays(1)}>Today</button>
<button onClick={() => handleDays(3)}>Last 3 Days</button>
<button onClick={() => handleDays(7)}>Last 7 Days</button>
<button onClick={() => handleDays(30)}>1 month</button>
      </div>
      <div style={{ overflowX: "auto", width: "100%" }}>
  {Loading ? (
    <Loader />
  ) : (
    <div style={{ minWidth: "600px" }}> {/* Adjust minWidth to make it scrollable */}
      <ApexCharts
        options={data?.options}
        series={data?.series}
        type="line"
        height={350}
      />
    </div>
  )}
</div>

    </div>
  );
};

export default LineChartApex;
